export interface IAppSettings {
  layout?: string;
  boxed?: boolean;
  sidebarOpened?: boolean;
  sidebarBg?: string;
  sidebarBg2?: string;
  sidebarColor?: string;
  sidebarContrast?: string;
  sidebarAccentColor?: string;
  sidebarAccentContrastColor?: string;
  topbarBg?: string;
  topbarColor?: string;
}

export enum AltisEmailSendProtocol {
  SMTP = 0,
  AzureGraph = 1,
}

export interface ISMTPConfig {
  credentialsEmailAddress?: string;
  emailAddress?: string;
  emailPass?: string;
  emailHost?: string;
  emailPort?: number;
  emailUseDefaultCredentials?: boolean;
  emailEnableSsl?: boolean;
}

export interface IGraphConfig {
  credentialsEmailAddress?: string;
  azureTenantId?: string;
  azureClientId?: string;
  azureClientSecret?: string;
  serviceURL?: string;
}

export interface IEmailSettings {
  sendProtocol: AltisEmailSendProtocol;
  mailIsActive: boolean;
  smtpConfig?: ISMTPConfig;
  graphConfig?: IGraphConfig;
}

export interface IGeneralSettings {
  jwtToken: string;
  imageBaseURL: string;
}

export interface ISettings {
  id?: string;
  mailAccount?: string;
  mailPass?: string;
  mailName?: string;
  port?: number;
  host?: string;
  credentials?: string;
}
